export const transformImgUrlToResolutions = (url: string, variant?: string) => {
  const imgUrl = variant ? `${url}/${variant}` : url
  const resolutions = transformImageResolutions(imgUrl)

  return {
    ...resolutions,
    default: url
  }
}

export function transformImageResolutions(url: string) {
  const resolutions = {
    '1x': `${url}_1x`,
    '2x': `${url}_2x`,
    '3x': url
  }

  return {
    ...resolutions,
    srcset: `${resolutions['1x']} 1x, ${resolutions['2x']} 2x, ${resolutions['3x']} 3x`
  }
}
